export default function Nisroom() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 601.59 609.76" aria-hidden="true" focusable="false" role="img">
      <circle cx="300.97" cy="232.63" r="232.63" fill="#e2844a" />
      <path
        d="M31,375.86a28.75,28.75,0,0,0,40.68,0L274,173.54c8.41-8.42,12.63-7.26,15.31-4.57,5.13,5.12,1.23,12.44-2.93,20l-50.55,87.66c-17.1,29.31-3.49,56.7,20.92,81.11,26.86,26.85,56.14,33.69,86.74,3.09L592.77,111.52,570.64,89.39a28.77,28.77,0,0,0-40.69,0l-202,202c-5.1,5.1-12.24,12.24-17.61,6.87-5.85-5.86.35-16,5.53-24.57l44.8-75.55c20.45-34.12,15.25-58.7-14-88s-57.31-36.91-90.46-3.76L8.82,353.73Z"
        fill="#f1c279"
      />
      <g id="角丸2">
        <path
          d="M132.69,598.51a10,10,0,0,1,10-10h37.64c4.13,0,4.89-1.32,4.89-2.64,0-2.52-2.76-3.36-5.64-4.2l-34-9.12c-11.41-3-14.8-13.08-14.8-25.07,0-13.2,5.52-22.08,20.56-22.08h57.91v10.88a10,10,0,0,1-10,10H164.66c-2.51,0-6,0-6,2.64,0,2.88,4,3.84,7.4,4.67l29.58,7.56c13.41,3.36,18.18,10.68,18.18,25.08s-5,23.16-21.31,23.16h-59.8Z"
          fill="#f1c279"
        />
        <path
          d="M10.88,609.19a10,10,0,0,0,10-10V559.55c0-4.13,1.32-4.88,2.64-4.88,2.52,0,3.36,2.75,4.2,5.64l9.12,34c3,11.4,13.08,14.79,25.08,14.79,13.2,0,22.08-5.52,22.08-20.56V525.6H73.12a10,10,0,0,0-10,10v39.62c0,2.51,0,6-2.64,6-2.88,0-3.84-4-4.68-7.4l-7.56-29.58c-3.36-13.41-10.68-18.17-25.08-18.17S0,531.1,0,547.4v61.79Z"
          fill="#f1c279"
        />
        <path d="M94.11,609.39v-74a10,10,0,0,1,10-10h17.12v74a10,10,0,0,1-10,10Z" fill="#f1c279" />
      </g>
      <path
        d="M223.67,538.22a13.2,13.2,0,0,1,13.2-13.2h47.4c19.2,0,24,10.56,24,28.56,0,12-1.92,29.88-18.72,29.88H286v.48L310,609H277.31l-16.2-21.84c-2.76-3.72-5.76-6.6-5.76-11.4V574a9.48,9.48,0,0,1,9.48-9.48h6.72a9.61,9.61,0,0,0,9.6-9.68c0-7-2.47-8.92-9.6-8.92H256.07a5.28,5.28,0,0,0-5.28,5.28V599a10,10,0,0,1-10,10H223.67Z"
        fill="#e2844a"
      />
      <path
        d="M399.19,567c0,36-6.4,42-41.2,42s-41.2-6-41.2-42,6.4-42,41.2-42S399.19,531,399.19,567ZM358,589.1c14.4,0,18.36-6.48,18.36-22.08s-4-22.08-18.36-22.08-18.36,6.48-18.36,22.08S343.59,589.1,358,589.1Z"
        fill="#e2844a"
      />
      <path
        d="M565.48,598.74c-1.65,6-3.71,11-13.89,11s-12.25-5-13.89-11l-11.11-39.66c-.41-1.52-.83-2.93-1.34-2.93-.93,0-.93,1.88-.93,2.7l.58,40c.08,5.46-3.78,9.94-8.57,9.94H501.59V540.19c0-14.43,14-14.43,17.69-14.43,6.17,0,14.82.94,18.52,13.61l11.63,39.89c.2.82,1.23,3.76,2.16,3.76s1.95-2.94,2.16-3.76l11.62-39.89c3.71-12.55,12.45-13.61,18.52-13.61,16.36,0,17.7,9.27,17.7,14.43v68.64H586.87c-4.8,0-8.67-4.49-8.58-10l.66-40c0-1.06-.1-2.7-.92-2.7-.41,0-.83.7-1.44,2.93Z"
        fill="#e2844a"
      />
      <path
        d="M491.59,567.76c0,36-6.4,42-41.2,42s-41.2-6-41.2-42,6.4-42,41.2-42S491.59,531.77,491.59,567.76Zm-41.2,22.08c14.4,0,18.36-6.48,18.36-22.08s-4-22.07-18.36-22.07S432,552.17,432,567.76,436,589.84,450.39,589.84Z"
        fill="#e2844a"
      />
    </svg>
  );
}
